
        var result = require("!!../../../../node_modules/css-loader/index.js!./roles-management.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/controls/roles-management.component.css
// module id = 678
// module chunks = 0